import KitLog from "../KitLog";
import KitAPI from "@/Fwk/Kit/KitAPI";
import {DeviceData} from "@/Fwk/Kit/Iap/DeviceData";
import { KitIAP } from "./KitIap";

export class SmIDQuery {

    // 数盟ID请求中
    static isQuery = false;
    static listeners = new Map<number, (id: number, sid: string) => void>();

    static QueryScene(scene: number, action: (id: number, sid: string) => void) {
        if (KitLog.IsLog) KitIAP.Log(`scene=${scene}, 获取数盟ID`);
        this.listeners.set(scene, action);
        this.Query();
    }

    static Query() {
        if (this.isQuery) return;
        this.isQuery = true;
        if (KitLog.IsLog) KitIAP.Log("开始获取数盟ID");
        KitAPI.QuerySmID(this.Handler);
    }

    static Handler(id: string) {
        DeviceData.putSmID(id);
        SmIDQuery.OnQuery();
        SmIDQuery.isQuery = false;
    }

    static OnQuery() {
        const id = DeviceData.GetSmID();
        if (KitLog.IsLog) KitIAP.Log(`获取数盟ID=${id}，保存以后用`);
        for (const [key, action] of this.listeners) {
            if (KitLog.IsLog) KitIAP.Log(`scene=${key}, 获取数盟ID=${id}`);
            action(key, id);
        }
    }

}
